export default "__VITE_ASSET__BzqWqJKL__"